import {
  setUser,
  setServiceList,
  setEnterpriseUser,
  getUser,
  setLastVisitedPage,
  setToken
} from './currentUserLocalStorage'
import { handleDefaultService, handleLogoutRequest } from '../users'
import { navigate } from 'gatsby'



export const currentUser = async (Userdata, accountType) => {
  if (accountType === 'individual') {
    try {
      // set auth token
      setToken(Userdata.authToken)

      if (
        Userdata.ServiceList !== 'undefined' &&
        Userdata.ServiceList.length !== 0
      ) {
        //Store default Service ID
        if (!!Userdata.DefaultService) {
          var defaultServiceID = Userdata.DefaultService
          var displayNameOriginal = ''
          var serviceType = ''
          var primaryID = ''
          var SecondaryID = ''
          var ContactPhone = ''
          var ContactEmail = ''
          var FirstName = ''
          var LastName = ''
          var serviceList = Userdata.ServiceList
          serviceList.filter(function (service) {
            if (service.ID === defaultServiceID) {
              displayNameOriginal = service.DisplayName.toLowerCase()
              serviceType = service.Type
              primaryID = service.primaryID
              SecondaryID = service.SecondaryID
              ContactPhone = service.ContactPhone
              FirstName = service.FirstName
              LastName = service.LastName
              ContactEmail = service.ContactEmail
            }
          })

          if (
            serviceType === '' &&
            serviceList.length > 0 &&
            serviceList[0].Type !== ''
          ) {
            let service = serviceList[0]
            displayNameOriginal = service.DisplayName.toLowerCase()
            serviceType = service.Type
            primaryID = service.primaryID
            SecondaryID = service.SecondaryID
            ContactPhone = service.ContactPhone
            FirstName = service.FirstName
            LastName = service.LastName
            ContactEmail = service.ContactEmail

            var displayName =
              displayNameOriginal.charAt(0).toUpperCase() +
              displayNameOriginal.slice(1)
            setUser({
              username: Userdata.Username,
              DisplayName: displayName,
              msisdn: Userdata.ServiceList[0].primaryID,
              DefaultServiceID: Userdata.DefaultService,
              serviceType: serviceType,
              primaryID: primaryID,
              SecondaryID: SecondaryID,
              ContactPhone: ContactPhone,
              FirstName: FirstName,
              LastName: LastName,
              ContactEmail: ContactEmail
            })

            setServiceList({
              serviceList: serviceList
            })

            return
          }

          var displayName =
            displayNameOriginal.charAt(0).toUpperCase() +
            displayNameOriginal.slice(1)
          setUser({
            username: Userdata.Username,
            DisplayName: displayName,
            msisdn: Userdata.ServiceList[0].primaryID,
            DefaultServiceID: Userdata.DefaultService,
            serviceType: serviceType,
            primaryID: primaryID,
            SecondaryID: SecondaryID,
            ContactPhone: ContactPhone,
            FirstName: FirstName,
            LastName: LastName,
            ContactEmail: ContactEmail
          })

          setServiceList({
            serviceList: serviceList
          })
        } else {
          handleDefaultService(
            Userdata.Username,
            Userdata.serviceList[0].ID
          ).then(res => {
            if (res.success === true) {
              setUser({
                FirstName: Userdata.DefaultService.FirstName,
                SecondaryID: Userdata.DefaultService.SecondaryID,
                primaryID: Userdata.DefaultService.primaryID,
                DisplayName: Userdata.DefaultService.DisplayName,
                serviceType: Userdata.DefaultService.Type,
                DefaultServiceID: Userdata.DefaultService.ID,
                username: getUser().username
              })
            }
          })
        }
      } else {
        setUser({ username: Userdata.Username })
      }
      return true
    } catch (error) {
      return false
    }
  } else {
    setEnterpriseUser({
      userID: Userdata[0].USERID,
      username: Userdata[0].USERNAME,
      contactPhone: Userdata[0].CONTACTNO
    })
  }
}

export const Logout = async (callback = () => true, clearLastVisited = false) => {
  await handleLogoutRequest()

  // if (clearLastVisited) {
  //   setLastVisitedPage("");
  //   sessionStorage.clear();
  // }
  localStorage.removeItem("hasLogin");
  sessionStorage.removeItem("data");
  setServiceList({});
  setToken("");
  setUser({})
  //clear user token from localStorage.
  localStorage.clear();
  

  callback();
  navigate(`${process.env.play_base_url}`);
};

export const currentEnterpriseUser = async Userdata => {
  try {
    setEnterpriseUser({
      userID: Userdata[0].USERID,
      username: Userdata[0].USERNAME,
      contactPhone: Userdata[0].CONTACTNO,
    })
    return true
  } catch (error) {
    return false
  }
}
